import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon/SvgIcon";

const ExclusionManual = ({ color = "#4280BF", ...props }) => (
  <SvgIcon {...props} viewBox="0 0 21 21">
    <g fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="nonzero"
        d="M10.5 10.5a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5zm0 2.62C7 13.12 0 14.88 0 18.38V21h21v-2.62c0-3.5-7-5.26-10.5-5.26z"
      />
      <path d="M-5-5h31v31H-5z" />
    </g>
  </SvgIcon>
);

export default ExclusionManual;
